'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _Requestable2 = require('./Requestable');

var _Requestable3 = _interopRequireDefault(_Requestable2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * @file
 * @copyright  2013 Michael Aufreiter (Development Seed) and 2016 Yahoo Inc.
 * @license    Licensed under {@link https://spdx.org/licenses/BSD-3-Clause-Clear.html BSD-3-Clause-Clear}.
 *             Github.js is freely distributable.
 */

/**
 * Project encapsulates the functionality to create, query, and modify cards and columns.
 */


var Project = function (_Requestable) {
  _inherits(Project, _Requestable);
  /**
   * Create a Project.
   * @param {string} id - the id of the project
   * @param {Requestable.auth} [auth] - information required to authenticate to Github
   * @param {string} [apiBase=https://api.github.com] - the base Github API URL
   */


  function Project(id, auth, apiBase) {
    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, auth, apiBase, 'inertia-preview'));

    _this.__id = id;
    return _this;
  }
  /**
   * Get information about a project
   * @see https://developer.github.com/v3/projects/#get-a-project
   * @param {Requestable.callback} cb - will receive the project information
   * @return {Promise} - the promise for the http request
   */


  _createClass(Project, [{
    key: 'getProject',
    value: function getProject(cb) {
      return this._request('GET', '/projects/' + this.__id, null, cb);
    }
    /**
     * Edit a project
     * @see https://developer.github.com/v3/projects/#update-a-project
     * @param {Object} options - the description of the project
     * @param {Requestable.callback} cb - will receive the modified project
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'updateProject',
    value: function updateProject(options, cb) {
      return this._request('PATCH', '/projects/' + this.__id, options, cb);
    }
    /**
     * Delete a project
     * @see https://developer.github.com/v3/projects/#delete-a-project
     * @param {Requestable.callback} cb - will receive true if the operation is successful
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'deleteProject',
    value: function deleteProject(cb) {
      return this._request('DELETE', '/projects/' + this.__id, null, cb);
    }
    /**
     * Get information about all columns of a project
     * @see https://developer.github.com/v3/projects/columns/#list-project-columns
     * @param {Requestable.callback} [cb] - will receive the list of columns
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'listProjectColumns',
    value: function listProjectColumns(cb) {
      return this._requestAllPages('/projects/' + this.__id + '/columns', null, cb);
    }
    /**
     * Get information about a column
     * @see https://developer.github.com/v3/projects/columns/#get-a-project-column
     * @param {string} colId - the id of the column
     * @param {Requestable.callback} cb - will receive the column information
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'getProjectColumn',
    value: function getProjectColumn(colId, cb) {
      return this._request('GET', '/projects/columns/' + colId, null, cb);
    }
    /**
     * Create a new column
     * @see https://developer.github.com/v3/projects/columns/#create-a-project-column
     * @param {Object} options - the description of the column
     * @param {Requestable.callback} cb - will receive the newly created column
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'createProjectColumn',
    value: function createProjectColumn(options, cb) {
      return this._request('POST', '/projects/' + this.__id + '/columns', options, cb);
    }
    /**
     * Edit a column
     * @see https://developer.github.com/v3/projects/columns/#update-a-project-column
     * @param {string} colId - the column id
     * @param {Object} options - the description of the column
     * @param {Requestable.callback} cb - will receive the modified column
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'updateProjectColumn',
    value: function updateProjectColumn(colId, options, cb) {
      return this._request('PATCH', '/projects/columns/' + colId, options, cb);
    }
    /**
     * Delete a column
     * @see https://developer.github.com/v3/projects/columns/#delete-a-project-column
     * @param {string} colId - the column to be deleted
     * @param {Requestable.callback} cb - will receive true if the operation is successful
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'deleteProjectColumn',
    value: function deleteProjectColumn(colId, cb) {
      return this._request('DELETE', '/projects/columns/' + colId, null, cb);
    }
    /**
     * Move a column
     * @see https://developer.github.com/v3/projects/columns/#move-a-project-column
     * @param {string} colId - the column to be moved
     * @param {string} position - can be one of first, last, or after:<column-id>,
     * where <column-id> is the id value of a column in the same project.
     * @param {Requestable.callback} cb - will receive true if the operation is successful
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'moveProjectColumn',
    value: function moveProjectColumn(colId, position, cb) {
      return this._request('POST', '/projects/columns/' + colId + '/moves', {
        position: position
      }, cb);
    }
    /**
     * Get information about all cards of a project
     * @see https://developer.github.com/v3/projects/cards/#list-project-cards
     * @param {Requestable.callback} [cb] - will receive the list of cards
     * @return {Promise} - the promise for the http request
     */

  }, {
    key: 'listProjectCards',
    value: function listProjectCards(cb) {
      var _this2 = this;

      return this.listProjectColumns().then(function (_ref) {
        var data = _ref.data;
        return Promise.all(data.map(function (column) {
          return _this2._requestAllPages('/projects/columns/' + column.id + '/cards', null);
        }));
      }).then(function (cardsInColumns) {
        var cards = cardsInColumns.reduce(function (prev, _ref2) {
          var data = _ref2.data;
          prev.push.apply(prev, _toConsumableArray(data));
          return prev;
        }, []);

        if (cb) {
          cb(null, cards);
        }

        return cards;
      }).catch(function (err) {
        if (cb) {
          cb(err);
          return;
        }

        throw err;
      });
    }
    /**
    * Get information about all cards of a column
    * @see https://developer.github.com/v3/projects/cards/#list-project-cards
    * @param {string} colId - the id of the column
    * @param {Requestable.callback} [cb] - will receive the list of cards
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'listColumnCards',
    value: function listColumnCards(colId, cb) {
      return this._requestAllPages('/projects/columns/' + colId + '/cards', null, cb);
    }
    /**
    * Get information about a card
    * @see https://developer.github.com/v3/projects/cards/#get-a-project-card
    * @param {string} cardId - the id of the card
    * @param {Requestable.callback} cb - will receive the card information
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'getProjectCard',
    value: function getProjectCard(cardId, cb) {
      return this._request('GET', '/projects/columns/cards/' + cardId, null, cb);
    }
    /**
    * Create a new card
    * @see https://developer.github.com/v3/projects/cards/#create-a-project-card
    * @param {string} colId - the column id
    * @param {Object} options - the description of the card
    * @param {Requestable.callback} cb - will receive the newly created card
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'createProjectCard',
    value: function createProjectCard(colId, options, cb) {
      return this._request('POST', '/projects/columns/' + colId + '/cards', options, cb);
    }
    /**
    * Edit a card
    * @see https://developer.github.com/v3/projects/cards/#update-a-project-card
    * @param {string} cardId - the card id
    * @param {Object} options - the description of the card
    * @param {Requestable.callback} cb - will receive the modified card
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'updateProjectCard',
    value: function updateProjectCard(cardId, options, cb) {
      return this._request('PATCH', '/projects/columns/cards/' + cardId, options, cb);
    }
    /**
    * Delete a card
    * @see https://developer.github.com/v3/projects/cards/#delete-a-project-card
    * @param {string} cardId - the card to be deleted
    * @param {Requestable.callback} cb - will receive true if the operation is successful
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'deleteProjectCard',
    value: function deleteProjectCard(cardId, cb) {
      return this._request('DELETE', '/projects/columns/cards/' + cardId, null, cb);
    }
    /**
    * Move a card
    * @see https://developer.github.com/v3/projects/cards/#move-a-project-card
    * @param {string} cardId - the card to be moved
    * @param {string} position - can be one of top, bottom, or after:<card-id>,
    * where <card-id> is the id value of a card in the same project.
    * @param {string} colId - the id value of a column in the same project.
    * @param {Requestable.callback} cb - will receive true if the operation is successful
    * @return {Promise} - the promise for the http request
    */

  }, {
    key: 'moveProjectCard',
    value: function moveProjectCard(cardId, position, colId, cb) {
      return this._request('POST', '/projects/columns/cards/' + cardId + '/moves', {
        position: position,
        column_id: colId
      }, // eslint-disable-line camelcase
      cb);
    }
  }]);

  return Project;
}(_Requestable3.default);

module.exports = Project; //# sourceMappingURL=Project.js.map